<template>
  <v-bottom-navigation class="hidden-lg-and-up align-center" dark app grow>
    <v-btn height="100%" to="/">
      <span>Home</span>
      <v-icon>mdi-home</v-icon>
    </v-btn>

    <v-btn height="100%" to="/character/warflash">
      <span>User</span>
      <v-icon>mdi-account</v-icon>
    </v-btn>

    <v-btn height="100%" to="/guilds">
      <span>Guilds</span>
      <v-icon>mdi-shield</v-icon>
    </v-btn>

    <v-btn height="100%" to="/leaderboards">
      <span>Leaderboards</span>
      <v-icon>mdi-trophy</v-icon>
    </v-btn>

    <v-btn height="100%" to="/timers">
      <span>Timers</span>
      <v-icon>mdi-timer-sand</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
export default {
  name: "BottomNavigation"
};
</script>
